<template>
    <div class="relative">
        <div
            id="bgMapBox"
            class="bg-grey-100 w-full"
            style="overflow: hidden"
            :style="{height: height}"
        >
            <canvas id="bgMap" class="mx-auto"></canvas>
        </div>

        <div class="absolute inset-0">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import NavBar from '@/Components/NavBar'
import * as d3 from 'd3'

export default {
    components: {
        NavBar,
    },

    props: {
        specials: {
            default: null,
        },

        height: {
            default: '500px',
        },

        countryColor: {
            default: '#444',
        },

        countryStrokeColor: {
            default: '#444',
        },

        activeCountryColor: {
            default: '#d21e23',
        },

        activeCountryStrokeColor: {
            default: '#ffffff',
        },
    },

    data () {
        return {
            canvas     : null,
            box        : null,
            projection : null,
            data       : null,
            resizeTimer: null,
        }
    },

    mounted () {
        this.canvas = document.getElementById('bgMap')
        this.box    = document.getElementById('bgMapBox')

        this.drawMap()
    },

    created () {
        window.addEventListener('resize', this.onResize)
    },

    destroyed () {
        window.removeEventListener('resize', this.onResize)
    },

    methods: {
        drawMap () {
            if (this.data === null) {
                this.loadData()

                return
            }

            // Actual width and height.
            let width  = this.box.offsetWidth
            let height = this.box.offsetHeight

            // Set dimensions of the canvas
            this.canvas.setAttribute('width', width.toString())
            this.canvas.setAttribute('height', height.toString())

            // Set a projection for the map. Projection = transform a lat/long on a position on the 2d map.
            let projection = d3.geoMercator()
                               .translate([width / 2, height / 2])

            // Get the 'context'
            let ctx = this.canvas.getContext('2d')

            // geographic path generator for given projection and canvas context
            const pathGenerator = d3.geoPath(projection, ctx)

            let _this = this
            this.data.features.forEach((i) => {
                // initialize the path
                ctx.beginPath()

                // Got the positions of the path
                pathGenerator(i)

                ctx.fillStyle   = this.countryColor
                ctx.strokeStyle = this.countryStrokeColor

                if (_this.specials !== null
                    && _this.specials.length > 0
                    && _this.specials.includes(i.id)
                ) {
                    ctx.fillStyle   = this.activeCountryColor
                    ctx.strokeStyle = this.activeCountryStrokeColor
                }

                ctx.fill()
                ctx.stroke()
            })
        },

        loadData () {
            let _this = this

            d3.json('/data/world.geojson')
              .then(function (data) {
                  _this.data = data

                  _this.drawMap()
              })
        },

        onResize () {
            let _this = this

            if (this.resizeTimer !== null) {
                clearTimeout(this.resizeTimer)

                this.resizeTimer = null
            }

            setTimeout(function () {
                _this.drawMap.call(_this)
            }, 200)
        },
    },
}
</script>
